/** Fine film grain so the particle field never reads as flatly digital. */
export default function Grain() {
    return (
        <svg
            style={{
                position: 'absolute',
                inset: 0,
                width: '100%',
                height: '100%',
                zIndex: 2,
                pointerEvents: 'none',
                opacity: 0.05,
                mixBlendMode: 'overlay',
            }}
            xmlns="http://www.w3.org/2000/svg"
        >
            <filter id="sgb">
                <feTurbulence
                    type="fractalNoise"
                    baseFrequency="0.9"
                    numOctaves="2"
                    stitchTiles="stitch"
                />
                <feColorMatrix type="saturate" values="0" />
            </filter>
            <rect width="100%" height="100%" filter="url(#sgb)" />
        </svg>
    );
}
